import { createFileRoute } from "@tanstack/react-router";
import { getHealthPackages } from "@/lib/server-functions";
import HealthPackagesPage from "@/pages/HealthPackages";
import ogImage from "@/assets/knmc-og.jpeg";
import { getPageUrl } from "@/lib/site";
import { packagesJsonLd } from "@/lib/jsonld";

export const Route = createFileRoute("/health-packages")({
  loader: async () => {
    const packages = await getHealthPackages();
    return { packages };
  },

  head: ({ loaderData }) => {
    const pageUrl = getPageUrl("/health-packages");

    return {
      meta: [
        {
          title: "Health Checkup Packages in Kathmandu — KNMC, Nepal",
        },
        {
          name: "description",
          content:
            "Affordable health checkup and screening packages in Kathmandu, Nepal at KNMC Hospital. Book preventive care online — reports in 48 hours.",
        },
        {
          name: "keywords",
          content:
            "health checkup Kathmandu, full body checkup Nepal, health packages Kathmandu, preventive screening Nepal, KNMC packages",
        },
        {
          property: "og:title",
          content: "Health Checkup Packages — Kathmandu, Nepal",
        },
        {
          property: "og:description",
          content:
            "Preventive care that pays for itself — book your screening at KNMC in Kathmandu.",
        },
        {
          property: "og:image",
          content: getPageUrl(ogImage),
        },
        {
          property: "og:url",
          content: pageUrl,
        },
        packagesJsonLd(loaderData?.packages ?? []),
      ],

      links: [
        {
          rel: "canonical",
          href: pageUrl,
        },
      ],
    };
  },

  component: () => {
    const { packages } = Route.useLoaderData();
    return <HealthPackagesPage packages={packages} />;
  },
});